var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let BasicCard = class BasicCard extends LitElement {
    constructor() {
        super(...arguments);
        this.align = 'left';
        this.size = 'medium';
    }
    render() {
        return html `
        <slot></slot>
    `;
    }
};
BasicCard.styles = css `
    :host {
      display: block;
      border: 1px solid #ddd;
      border-radius: 12px;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
      background: white;
      padding: 20px;
      box-sizing: border-box;
    }

    :host([size="small"]) {
      border-radius: 8px;
      padding: 12px;
    }
    :host([size="medium"]) {
      border-radius: 12px;
      padding: 20px;
    }
    :host([size="large"]) {
      border-radius: 24px;
      padding: 32px;
    }

    :host([align="center"]) {
      text-align: center;
    }

    :host([align="right"]) {
      text-align: right;
    }
  `;
__decorate([
    property({ type: String })
], BasicCard.prototype, "align", void 0);
__decorate([
    property({ type: String })
], BasicCard.prototype, "size", void 0);
BasicCard = __decorate([
    customElement('basic-card')
], BasicCard);
export { BasicCard };
//# sourceMappingURL=BasicCard.js.map